import { SmartSendItemApiModel } from '~/lib/api/smartsend/types';
import { SettingsCache } from '~/lib/consts/settings-cache';

const senderCountries = [
  { CountryIsoCode: 'GBR', CountrySubdivision: null },
  { CountryIsoCode: 'GBR', CountrySubdivision: '' },
  { CountryIsoCode: 'GBR', CountrySubdivision: 'HIGH' }
];
const recipientCountry = { CountryIsoCode: 'GBR', CountrySubdivision: 'NIR' };

export function IsWindsor(x: SmartSendItemApiModel) {
  if (SettingsCache.settings.Features.includes('Windsor')) {
    return (
      senderCountries.some(
        (s) => s.CountryIsoCode === x.Sender?.CountryIsoCode && s.CountrySubdivision === x.Sender?.CountrySubdivision
      ) &&
      x.Recipient?.CountryIsoCode === recipientCountry.CountryIsoCode &&
      x.Recipient?.CountrySubdivision === recipientCountry.CountrySubdivision
    );
  }

  return false;
}
